import { useCallback } from 'react';
import { ClientApi, ToastStateHandler } from '../../api';
import { useContainer } from '../useContainer';
import { useTranslation } from '../useTranslation';
import { InvoiceStatus } from '@cyberlabrs/helpers';

const useHttpPatchInvoiceStatus = () => {
    const clientApi = useContainer(ClientApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const changeStatus = useCallback(
        async (id: string, status: InvoiceStatus) => {
            const { exec } = clientApi.changeStatus({
                params: { id, status },

                onSuccess: () => {
                    toastHandler.push('success', t('invoice.statusChangeTitle'), t('invoice.statusChangeSuccessMessage'));
                },
                onError: () => {
                    toastHandler.push('error', t('invoice.statusChangeTitle'), t('invoice.statusChangeErrorMessage'));
                },
            });

            exec();
        },
        [clientApi, toastHandler, t]
    );

    return { changeStatus };
};

export default useHttpPatchInvoiceStatus;
